import { render, staticRenderFns } from "./CostosReposicion.vue?vue&type=template&id=b96304f6&"
import script from "./CostosReposicion.vue?vue&type=script&lang=js&"
export * from "./CostosReposicion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports